//libraries
import { initAOS } from './lib/aos';
import { initFancybox } from './lib/fancybox';

// modules sliders
import { initAllSwipers } from './modules/sliders';
import { initHeader } from './modules/header';
import { initMap } from './modules/map';
import { initAllScript } from './modules/script';
import { initScrollSmoother } from './modules/script';

initScrollSmoother();

document.addEventListener('DOMContentLoaded', () => {
	initHeader();
	initAOS();
	initFancybox();

	initMap();

	initAllSwipers();
	initAllScript();
});
